import http from '../../../plugins/axios';
// const financialname = '/financialSystem'
const financialname = ''
export default {
  coinSetting(data) {
    return http.get({
      url: '/admin/finance/psi/currencyConfig/findList',
      data
    });
  },
  batchEdit(data) {
    return http.post({
      url: '/admin/finance/psi/currencyConfig/batchEdit',
      data,
      headers: {
          'Content-Type': 'application/json'
      }
    });
  },
  psipage(data) {
    return http.get({
      url: '/admin/finance/psi/statistic/page',
      data,
    });
  },
  updateStatistics(data) {
    return http.post({
      url: '/admin/finance/psi/statistic/updateStatistics',
      data
    });
  },
  currencyConfigdel(data) {
    return http.get({
      url: '/admin/finance/psi/currencyConfig/del',
      data
    });
  },
  export(data) {
    return http.get({
      url: '/admin/finance/psi/statistic/export',
      data,
      responseType: 'blob'
    });
  },
  getCoinTypes() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  },
  // coinSetting(data) {
  //   return http.get({
  //     url: financialname+'/financialmanage/psi/currencyConfig/findList',
  //     data
  //   });
  // },
  // batchEdit(data) {
  //   return http.post({
  //     url: financialname+'/financialmanage/psi/currencyConfig/batchEdit',
  //     data,
  //     headers: {
  //         'Content-Type': 'application/json'
  //     }
  //   });
  // },
  // psipage(data) {
  //   return http.get({
  //     url: financialname+'/financialmanage/psi/statistic/page',
  //     data,
  //   });
  // },
  // updateStatistics(data) {
  //   return http.post({
  //     url: financialname+'/financialmanage/psi/statistic/updateStatistics',
  //     data
  //   });
  // },
  // currencyConfigdel(data) {
  //   return http.get({
  //     url: financialname+'/financialmanage/psi/currencyConfig/del',
  //     data
  //   });
  // },
  // export(data) {
  //   return http.get({
  //     url: financialname+'/financialmanage/psi/statistic/export',
  //     data,
  //     responseType: 'blob'
  //   });
  // },
  // getCoinTypes() {
  //   return http.get({
  //     url: '/admin/coin/allDisplay'
  //   });
  // },
};
